import { OfferList } from 'shared/components/OfferList';
import { useSelector } from 'react-redux';
import { selectCalculatorValues, selectCalculatorErrors } from 'shared/selectors/landing';
import { MortgageOfferValidation } from 'shared/components/MortgageOfferValidation';
import { getBanksLogos } from '../../selectors/dictionaries';
import { CreditInfoModalContainer } from '../CreditInfoModalContainer';
import { selectIsAuthorizedModalOpen } from '../../selectors/landing/selectIsAuthorizedModalOpen';
import { LoginWidgetB2CContainer } from '../microfrontends/LoginWidgetB2CContainer';

export const MortgageOfferContainer = () => {
  const calculatorValues = useSelector(selectCalculatorValues);
  const banksLogos = useSelector(getBanksLogos);
  const calculatorErrors = useSelector(selectCalculatorErrors);

  const isAuthorizedModalOpen = useSelector(selectIsAuthorizedModalOpen);

  if (!calculatorValues || calculatorErrors.length > 0) {
    return <MortgageOfferValidation errors={calculatorErrors} bankList={banksLogos} />;
  }

  return (
    <>
      <OfferList calculatorValues={calculatorValues} />
      <CreditInfoModalContainer />
      {isAuthorizedModalOpen && <LoginWidgetB2CContainer />}
    </>
  );
};
